export default "__VITE_ASSET__FQUEAyZ7__"